<template>
  <div class="o-card u-padding-xsmall u-display-flex">
    <Button
      @click="project.isPermission && (lockedModal.status = true)"
      :disabled="!project.isPermission"
      class="u-margin-right-xsmall"
      block
      :variant="project.isLocked ? 'light-danger' : 'light-success'"
    >
      <i :class="`icofont-ui-${project.isLocked ? '' : 'un'}lock`"></i>
      {{
        project.isLocked ? $t("common.lockedText") : $t("common.unlockedText")
      }}
    </Button>
    <router-link
      class="u-width-100% u-margin-right-xsmall"
      :to="`/projects/${project.id}/copy`"
    >
      <Button block variant="light-primary">
        {{ $t("common.copy") }}
      </Button>
    </router-link>
    <Button
      :disabled="!project.isPermission || project.isLocked"
      @click="
        (project.isPermission || project.isLocked) &&
          (removeModal.status = true)
      "
      block
      variant="light-danger"
    >
      <i
        :class="`icofont-${
          project.isPermission && !project.isLocked ? 'trash' : 'ui-lock'
        } u-margin-right-xsmall`"
      ></i>
      {{ $t("common.remove") }}
    </Button>
    <LockedModal
      v-model="lockedModal.status"
      :description="$t(`updateProjects.${SET_LOCKED_DESCRIPTION()}`)"
      :okText="$t(`common.${SET_LOCKED_DESCRIPTION()}`)"
      @ok="LOCKED_ITEM"
    ></LockedModal>
    <RemoveModal @ok="REMOVE_ITEM" v-model="removeModal.status"></RemoveModal>
  </div>
</template>

<script>
import Button from "@/components/Base/Button.vue";
import Requests from "@/services/Requests";
import LockedModal from "@/components/Shared/LockedModal/index.vue";
import RemoveModal from "@/components/Shared/RemoveModal/index.vue";
export default {
  name: "ActionBar",
  components: {
    Button,
    LockedModal,
    RemoveModal,
  },
  data() {
    return {
      lockedModal: {
        status: false,
      },
      removeModal: {
        status: false,
      },
    };
  },
  props: {
    project: {
      default: () => ({}),
    },
  },
  methods: {
    SET_LOCKED_DESCRIPTION() {
      return this.project.isLocked ? "unlocked" : "locked";
    },
    async REMOVE_ITEM(loading) {
      loading(true);

      const response = await this.$store.dispatch("removeProject", {
        id: this.project.id,
      });
      if (response.message === "OK") {
        this.$router.push({ name: "projects" });
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`removeProjects.success`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`removeProjects.error`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async LOCKED_ITEM(loading) {
      loading(true);
      const response = await Requests.Project.UpdateLockStatus(
        { params: { id: this.project.id } },
        { isLocked: !this.project.isLocked }
      );
      if (response.message === "OK") {
        this.$emit("refresh");
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`updateProjects.success`),
          variant: "success",
          duration: 2500,
        });
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`updateProjects.error`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
  },
};
</script>

<style></style>
